import { DASHBOARD_MODERATED } from "../actions/types";

const initialState = {
  tests: [],
  test: null,
  error: null,
  isLoading: false,
  runningSessions: [],
  totalRunningSessions: 0,
  inviteTeamProjectObj: null,
  inviteCollaboratorsObj: null,
  transcriptionLanguages: {},
  chooseSessionTypeProject: null,
  projectModalConfigs: { open: false, sessionMode: null, project: null, initUserInterview: false },
  instantSessionConfigs: {
    open: false,
    sessionMode: null,
    projectId: null,
    createNewTest: false,
    initUserInterview: false,
  },
};

export default function dashboardModeratedReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case DASHBOARD_MODERATED.LOAD:
      return { ...state, isLoading: true, ...payload };

    case DASHBOARD_MODERATED.UPDATE:
      if (payload?.projectModalConfigs === null) {
        payload.projectModalConfigs = initialState?.projectModalConfigs;
      }

      if (payload?.instantSessionConfigs === null) {
        payload.instantSessionConfigs = initialState?.instantSessionConfigs;
      }

      return { ...state, isLoading: false, ...payload };

    case DASHBOARD_MODERATED.RESET:
      return initialState;

    case DASHBOARD_MODERATED.ERROR:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
}
